"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAYMENT_STATUS = exports.PAYMENT_METHODS = exports.PAYLATER_BANK_DETAILS = exports.ORDER_POLLING_DURATION_IN_MIN = exports.LOYALTY_METHODS = exports.HOTEL_ORDER_END_USER_STATUS = exports.FURSAN_VALIDATION_CODES = exports.FLIGHT_BOOKING_STATUS = exports.ENDPOINTS = exports.CART_PRODUCT_TYPES = exports.BOOKING_STATUS_MESSAGES = exports.BOOKING_STATUS = exports.BOOKING_METHODS = exports.BLOCK_REWARDS = exports.ACTION_TYPES = void 0;
var ENDPOINTS = {
  HOTELS: {
    CREATE_EMPTY_CART: '/api/enigma/cart',
    UPDATE_CART: '/api/enigma/cart',
    GET_CART: '/api/enigma/cart/{cartId}',
    CHECKOUT: '/api/enigma/cart/checkout?{cartId}',
    PAYLATER_CHECKOUT: '/api/enigma/order/pay/{orderNumber}/{trackId}',
    APPLY_COUPON: '/api/enigma/cart/{cartId}/coupon/{couponCode}',
    REMOVE_COUPON: '/api/enigma/cart/{cartId}/coupon',
    GET_INSTALLMENTS: '/api/enigma/installment/plans',
    LOYALTY_REDEEM: '/api/enigma/loyalty/redeem',
    GET_ORDER: '/api/enigma/order/{orderNumber}?id={orderId}&noLoad=true&number={orderNumber}'
  },
  FLIGHTS: {
    CREATE_CART_V1: '/api/flight/quote/itineraryId/{itineraryId}',
    CREATE_CART: '/api/v3/flights/flight/quote/itineraryId/{itineraryId}',
    GET_CART: '/api/v3/flights/flight/cart/{cartId}',
    SEAT_RESERVATION: '/api/flight/seat/reservation',
    SEAT_RESERVATION_V3: '/api/v3/flights/flight/seat/reservation',
    CHECKOUT: '/api/flight/cart/checkout?{cartId}',
    APPLY_COUPON: '/api/v3/flights/flight/cart/{cartId}/coupon/{couponCode}',
    REMOVE_COUPON: '/api/v3/flights/flight/cart/{cartId}/coupon',
    GET_INSTALLMENTS: '/api/v3/flights/flight/installment/get-plans',
    LOYALTY_REDEEM: '/api/v3/flights/flight/loyalty/redeem',
    GET_ORDER: '/api/v3/flights/flight/order?id={orderId}&number={orderNumber}',
    UPDATE_SSR: '/api/flight/ssr/update',
    UPDATE_SSR_V3: '/api/v3/flights/flight/ssr/update'
  },
  CART: {
    GET_ORDER: '/api/checkout/order?id={orderId}',
    CREATE_CART: 'api/checkout/cart',
    GET_CART: '/api/checkout/cart/{cartId}',
    CHECKOUT: '/api/checkout/cart/{cartId}/checkout',
    APPLY_COUPON: '/api/checkout/cart/{cartId}/coupon/{couponCode}',
    REMOVE_COUPON: '/api/checkout/cart/{cartId}/coupon',
    LOYALTY_REDEEM: '/api/checkout/cart/{cartId}/redeem',
    INIT_REDEEM: '/api/checkout/cart/{cartId}/init-redeem'
  },
  GIFTCARD: {
    SEARCH: '/api/checkout/product/search'
  },
  ACCOMMODATION: {
    GET_ORDER: '/api/accommodation/order/{orderId}',
    GET_CART: '/api/accommodation/cart/{cartId}',
    CHECKOUT: '/api/accommodation/cart/{cartId}/checkout',
    APPLY_COUPON: '/api/accommodation/cart/{cartId}/coupon/{couponCode}',
    REMOVE_COUPON: '/api/accommodation/cart/{cartId}/coupon',
    LOYALTY_REDEEM: '/api/accommodation/cart/redeem'
  },
  PAYMENT_REQUEST: {
    GET_PAYMENT_REQUEST: '/api/hub/payment-requests/detail-to-process/{requestId}',
    GET_INSTALLMENTS: '/api/hub/installment/get-plans',
    CHECKOUT: '/api/hub/payment-requests/pay/{requestId}/{method}'
  },
  APPLE_PAY: {
    VALIDATE_SESSION: '/api/payment-api/card/apple-pay/validate-merchant',
    TOKEN: '/api/payment-api/card/apple-pay/token'
  },
  CHECK_PAYMENT_3D_SECURE: '/api/check-payment-3ds?_c={pollingCount}&_t={pollingStartTime}',
  QITAF_INIT_REDEEM: '/api/loyalty/init-redeem',
  CALCULATE_REWARD: '/api/loyalty/calculate-reward',
  CALCULATE_REWARD_BULK: '/api/loyalty/bulk-calculate-reward',
  VALIDATE_IDENTIFIER: '/api/loyalty/validate-identifier',
  LOYALTY_MAX_BURN: '/api/loyalty/max-burn',
  LOYALTY_CHECK_BALANCE: '/api/loyalty/check-balance',
  CMS_PAGE: '/api/cms/page',
  ORDER_PDF_URL: '/api/email-server/download-order-pdf/{orderNumber}/{orderId}',
  STATIC_RESOURCES: '/api/static/resources'
};
exports.ENDPOINTS = ENDPOINTS;
var LOYALTY_METHODS = {
  QITAF: 'qitaf',
  FURSAN: 'fursan',
  WALLET: 'wallet',
  MOKAFAA: 'mokafa'
};
exports.LOYALTY_METHODS = LOYALTY_METHODS;
var CART_PRODUCT_TYPES = {
  VAT: 'vat',
  INSURANCE: 'insurance',
  RULE: 'rule',
  COUPON: 'coupon',
  LOYALTY: 'loyalty',
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  ACCOMMODATION: 'accommodation',
  QITAF: 'qitaf',
  WALLET: 'wallet',
  GIFTCARD: 'gift-card'
};
exports.CART_PRODUCT_TYPES = CART_PRODUCT_TYPES;
var ACTION_TYPES = {
  CREATE_CART: 'CREATE_CART',
  FETCH_CART: 'FETCH_CART',
  QITAF_REDEEM: 'QITAF_REDEEM',
  WALLET_REDEEM: 'WALLET_REDEEM',
  APPLY_COUPON: 'APPLY_COUPON',
  REMOVE_COUPON: 'REMOVE_COUPON',
  UPDATE_CART: 'UPDATE_CART',
  UPDATE_FLIGHT_SSR: 'UPDATE_FLIGHT_SSR',
  CHECKOUT_CART: 'CHECKOUT_CART',
  INIT_REDEEM: 'INIT_REDEEM'
};
exports.ACTION_TYPES = ACTION_TYPES;
var BOOKING_METHODS = {
  PAY_NOW: 'paynow',
  PAY_LATER: 'paylater'
};
exports.BOOKING_METHODS = BOOKING_METHODS;
var PAYMENT_METHODS = {
  CHECKOUTCOM: 'checkoutcom',
  PAYFORT: 'payfort',
  TAJAWAL_PAY: 'tp',
  PAY_LATER: 'op',
  INSTALLMENTS: 'installments',
  FORT: 'fort',
  KNET: 'knet',
  THREE_D_SECURE: '3dsecure',
  QITAF: 'qitaf',
  WALLET: 'wallet',
  APPLE_PAY: 'apple-pay'
};
exports.PAYMENT_METHODS = PAYMENT_METHODS;
var BOOKING_STATUS = {
  FAILURE: 91,
  CANCELLED: 94,
  SUCCESS: 58,
  PENDING: 71
};
exports.BOOKING_STATUS = BOOKING_STATUS;
var FLIGHT_BOOKING_STATUS = {
  SUCCESS: 58,
  FAILURE: 60,
  CANCELLED: 94,
  REFUNDED: 95,
  MANUALLY_CANCELLED: 96,
  CANCEL_ON_PROCESSING: 102
};
exports.FLIGHT_BOOKING_STATUS = FLIGHT_BOOKING_STATUS;
var PAYMENT_STATUS = {
  AUTHORIZED: 78,
  AUTHORIZED_WITH_INSTALLMENTS: 80,
  PENDING: 71
};
exports.PAYMENT_STATUS = PAYMENT_STATUS;
var BOOKING_STATUS_MESSAGES = {
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
  UNAVAILABLE: 'UNAVAILABLE',
  PROCESSING: 'PROCESSING'
};
exports.BOOKING_STATUS_MESSAGES = BOOKING_STATUS_MESSAGES;
var FURSAN_VALIDATION_CODES = {
  VALID_IDENTIFIER: '1030',
  INVALID_IDENTIFIER: '1031'
};
exports.FURSAN_VALIDATION_CODES = FURSAN_VALIDATION_CODES;
var ORDER_POLLING_DURATION_IN_MIN = 3;
exports.ORDER_POLLING_DURATION_IN_MIN = ORDER_POLLING_DURATION_IN_MIN;
var HOTEL_ORDER_END_USER_STATUS = {
  CONFIRMED: 'CONFIRMED',
  CONFIRMING_WITH_HOTEL: 'CONFIRMING_WITH_HOTEL',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  CANCELLED_PAY_NOW: 'CANCELLED_PAY_NOW',
  CANCELLED_PAY_LATER: 'CANCELLED_PAY_LATER',
  NOT_CONFIRMED: 'NOT_CONFIRMED',
  STAY_COMPLETED: 'STAY_COMPLETED'
};
exports.HOTEL_ORDER_END_USER_STATUS = HOTEL_ORDER_END_USER_STATUS;
var PAYLATER_BANK_DETAILS = {
  SA: [{
    name: 'Al Rajhi',
    accountNumber: '296608010916669',
    ibanNumber: 'SA1580000296608010916669'
  }, {
    name: 'Al Ahly',
    accountNumber: '26063884000303',
    ibanNumber: 'SA2710000026063884000303'
  }, {
    name: 'Sabb',
    accountNumber: '011499555001',
    ibanNumber: 'SA450000000011499555001'
  }, {
    name: 'Inmaa',
    accountNumber: '0068200532030000',
    ibanNumber: 'SA3105000068200532030000'
  }, {
    name: 'Al Riyadh',
    accountNumber: '2070852499940',
    ibanNumber: 'SA5820000002070852499940'
  }],
  KW: [{
    name: 'National Bank of Kuwait S.A.K.P',
    accountNumber: '2022752648',
    ibanNumber: 'KW41NBOK0000000000002022752648'
  }],
  AE: [{
    name: 'Mashreqbank',
    accountNumber: '19100109717',
    ibanNumber: 'AE970330000019100109717'
  }]
};
exports.PAYLATER_BANK_DETAILS = PAYLATER_BANK_DETAILS;
var BLOCK_REWARDS = 'blockedRewards';
exports.BLOCK_REWARDS = BLOCK_REWARDS;